import React from 'react'

/**
* Top section of the `Footer` component.
* Currently just for the "Back to Top" button.
*/
const FooterTopContent = (props) => {
  const onClickHandler = (e) => {
    e.preventDefault()
    $.track('event', 'Footer', 'Back to Top', location.pathname, undefined, true, () => {
      // scroll to the top
      document.body.scrollTop = 0 // For Chrome, Safari and Opera
      document.documentElement.scrollTop = 0 // For IE and Firefox
    })
  }

  return (
    <section className="top-content">
      <a
        href="#"
        className="back-to-top-button"
        onClick={onClickHandler}
      >
        Back to Top
      </a>
    </section>
  )
}

export default FooterTopContent
